import { render, staticRenderFns } from "./operationResponsibilityAssign.vue?vue&type=template&id=1830aa16&scoped=true&"
import script from "./operationResponsibilityAssign.vue?vue&type=script&lang=js&"
export * from "./operationResponsibilityAssign.vue?vue&type=script&lang=js&"
import style0 from "./operationResponsibilityAssign.vue?vue&type=style&index=0&id=1830aa16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1830aa16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1830aa16')) {
      api.createRecord('1830aa16', component.options)
    } else {
      api.reload('1830aa16', component.options)
    }
    module.hot.accept("./operationResponsibilityAssign.vue?vue&type=template&id=1830aa16&scoped=true&", function () {
      api.rerender('1830aa16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/airConfig/tabs/operationResponsibilityAssign.vue"
export default component.exports